export default "__VITE_ASSET__SpLHTKbm__"